module.exports = __webpack_public_path__ + "img/thumb_08.09e9a2a8.jpg";